import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col" data-id="element-116">
      <Header data-id="element-117" />
      <main className="flex-grow pt-[88px]" data-id="element-118">{children}</main>
      <Footer data-id="element-119" />
    </div>;
}